
























import { Component, Vue } from 'vue-property-decorator';
import { panoramicQueryServer, zyScreenServer } from '@/api/installServer';

@Component({
  components: {},
})
export default class RiskEntList extends Vue {
  private dialogVisible = false;
  private title = '';

  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total: any = 0;
  private tableData: any = [];
  private tableLoading: any = false;
  private state: any = '';

  private showDialog(data: any) {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.title = data === '0' ? '红码' : data === '1' ? '黄码' : '绿码';
    this.state = data;
    this.getData();
    this.dialogVisible = true;
  }

  private getData() {
    this.tableLoading = true;
    panoramicQueryServer
      .getInfoList({
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        state: this.state,
      })
      .then((res: any) => {
        if (res.code == 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.$message.warning(res.data.msg);
        }
      });
  }
  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getData();
  }

  handleClose(done: any) {
    done();
  }
}
